<template>
    <span>
        <span v-html="content" />
        <span v-if="contentExtra"><em>{{ contentExtra }}</em></span>
    </span>
</template>
<script>

import SpeakTextContent from "./SpeakTextContent.vue";

export default {
	name: 'PartOfSpeachHeader',
    components: {
        SpeakTextContent,
    },
    data(){
        return {
            partOfSpeachSnId: 0,
            initialLangCode: 'E-N',
            langCode: '',
            identifier: '',
            content: '',
            contentExtra: '',
            contentExtraList: {},
        }
    },
	props:{
        snId: {
            required: false,
            default: () => (0)
        },
        lemInfo: {
            required: false,
            default: () => ({})
        },
        katInfo: {
            required: false,
            default: () => ({})
        },
        partOfSpeachInfo: {
            required: false,
            default: () => ({})
        },
        norskOrdbank: {
            required: false,
            default: () => ({})
        }
	},
    mounted() {
        this.initContent();
    },
    methods:{
        initContent() {
            if (typeof this.snId === 'number' && this.snId > 0) {
                this.partOfSpeachSnId = this.snId;
            } else {
                return;
            }

            if (!this.partOfSpeachSnId &&
                this.norskOrdbank !== undefined &&
                typeof this.norskOrdbank.sn_id === 'number') {
                this.partOfSpeachSnId = this.norskOrdbank['sn_id'];
            }

            this.initFromLanguageCode();
            this.initLangCode();

            let snId = this.partOfSpeachSnId;
            let contentExtra = '';
            let content = '';

            if (this.langCode &&
                this.partOfSpeachInfo !== undefined &&
                this.partOfSpeachInfo.sn_map !== undefined &&
                this.partOfSpeachInfo.sn_map[snId] !== undefined &&
                this.partOfSpeachInfo.sn_map[snId][this.langCode] !== undefined) {
                if (this.partOfSpeachInfo.sn_map[snId][this.langCode].content !== undefined) {
                    content = this.partOfSpeachInfo.sn_map[snId][this.langCode].content;
                }
                if (this.partOfSpeachInfo.sn_map[snId][this.langCode].content_extra !== undefined) {
                    contentExtra = this.partOfSpeachInfo.sn_map[snId][this.langCode].content_extra;
                }
            }

            if (!content && this.katInfo !== undefined &&
                this.katInfo.text !== undefined &&
                this.katInfo.text) {
                content = this.katInfo.text;
            }

            this.contentExtra = contentExtra;
            this.content = content;
        },
        initFromLanguageCode() {
            if (this.$route.params.dictionary !== undefined) {
                let dictionary = this.$route.params.dictionary.split('-')[0].split('.')[1];
                if (dictionary === "nynorsk") {
                    this.initialLangCode = 'Nny';
                }
            }
        },
        getLangCodeFromSnMap(snId) {
            let langCode = this.langCode;
            if (langCode &&
                this.partOfSpeachInfo.sn_map[snId] !== undefined &&
                this.partOfSpeachInfo.sn_map[snId][langCode] !== undefined &&
                this.partOfSpeachInfo.sn_map[snId][langCode].identifier !== undefined) {
                let identifier = this.partOfSpeachInfo.sn_map[snId][langCode].identifier;
                if (this.partOfSpeachInfo[langCode] !== undefined &&
                    this.partOfSpeachInfo[langCode][identifier] !== undefined) {

                    return langCode;
                }
            }

            return '';
        },
        initLangCode() {
            let langCode = '';
            if (this.katInfo.type !== undefined) {
                langCode = this.katInfo.type.split('-')[0];
                if (langCode === 'N' || langCode === 'E') {
                    langCode = 'E-N';
                }
            } else if (this.lemInfo.type !== undefined) {
                langCode = this.lemInfo.type.split('-')[0];
                if (langCode === 'N' || langCode === 'E') {
                    langCode = 'E-N';
                }
            } else if (this.norskOrdbank.language_code !== undefined &&
                ['nob', 'nno'].includes(this.norskOrdbank.language_code)) {
                if (this.norskOrdbank.language_code === 'nob') {
                    langCode = 'E-N';
                } else if (this.norskOrdbank.language_code === 'nno') {
                    langCode = 'Nny';
                }
            }

            this.langCode = langCode;
        },
        getTranslatedValue(value) {
            if (this.$te(value)) {
                return this.$t(value);
            } else {
                return value;
            }
        }
    }
}
</script>
